import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DetailFrame } from '@/features/shipment-detail/frame';

// S02–S07: the shipment's header and tabs around the tab's own route.
export const Route = createFileRoute('/_app/shipments/$id')({
  staticData: { ownPhoneHeader: true },
  component: ShipmentDetailLayout,
});

function ShipmentDetailLayout() {
  const { id } = Route.useParams();
  return (
    <DetailFrame id={id}>
      <Outlet />
    </DetailFrame>
  );
}
